<template>
  <div>
    <div class="padding-container-sm">
      <div class="row">
        <div class="col-md-6">
          <div class="col d-flex">
            <div class="d-flex searchFilter">
              <b-input-group size="md">
                <b-input-group-text slot="append" class="bg-white">
                  <strong>
                    <i class="ion-md-search" />
                  </strong>
                </b-input-group-text>
                <b-form-input
                  class="border-right-0"
                  :value="filter.searchValue"
                  placeholder="Search for patient or ID"
                  @keyup.enter.native="onSearchText"
                  @blur.native="onSearchText"
                />
              </b-input-group>
            </div>
            <div class="btn btn-link" @click="resetFilters">
              <strong>
                <i class="ion-md-refresh mr-1" />
              </strong>Reset
            </div>
          </div>
        </div>
        <div class="col-md-6 pb-6 text-right">
          <b-input-group size="md">
            <v-date-picker
              class="mb-6 datePicker mb-6 w-50"
              :value="filter.fromDate"
              position="bottom"
              @onChange="onFilterStartDateChange"
            />
            <v-date-picker
              class="mb-6 datePicker mb-6 w-50"
              :value="filter.toDate"
              position="bottom"
              @onChange="onFilterEndDateChange"
            />
          </b-input-group>
        </div>
      </div>
    </div>
    <v-table :options="tableProps" :total-count="Number(totalCount)" :data="reports">
      <template slot="createdAt" slot-scope="slotProps">
        <span v-if="slotProps">{{ defaultDateFormat(slotProps.data.datum.created_at) }}</span>
      </template>

      <template slot="patientName" slot-scope="slotProps">
        <div class="d-flex flex-column justify-content-center" v-if="slotProps">
          <span>
            {{ slotProps.data.datum.first_name | capitalizefirst }}
            {{ slotProps.data.datum.last_name | capitalizefirst }}
          </span>
        </div>
      </template>

      <template slot="symptoms" slot-scope="slotProps">
        <div class="d-flex flex-column justify-content-center alertCell" v-if="slotProps">
          <span class="unassigned w-100 text-break">
            <b>{{ slotProps.data.datum.description ? slotProps.data.datum.description.split(":")[0] : "" }}</b>
            <b v-if="slotProps.data.datum.value">- {{ slotProps.data.datum.value }}</b>
          </span>
        </div>
      </template>
    </v-table>
    <v-loader :isLoading="isLoading" />
  </div>
</template>

<script>
import VTable from "@/components/table/index.vue";
import VLoader from "@/components/loader/index.vue";
import { mapGetters } from "vuex";

export default {
  name: "PatientSymptoms",
  components: {
    VTable,
    VLoader
  },
  data() {
    return {
      filter: {
        searchValue: "",
        limit: 20,
        pageNo: 1,
        fromDate: this.getFormattedDate(),
        toDate: this.getFormattedDate()
      },
      tableProps: {
        columns: [
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellSlot: {
              name: "patientName"
            },
            dataKey: "first_name",
            dataType: String,
            label: "Patient Name"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },cellSlot: {
              name: "symptoms"
            },
            dataKey: "description",
            dataType: String,
            label: "Symptoms"
          },
          {
            headerCellProps: {
              class: "header-cell"
            },
            cellSlot: {
              name: "createdAt"
            },
            dataKey: "created_at",
            dataType: String,
            label: "Reported Date"
          }
        ],
        enableSelect: false,
        onPageChange: this.onPageChange,
        page: 1,
        rowProps: {},
        rowsPerPage: 20,
        title: "Resolved reports"
      }
    };
  },
  computed: {
    ...mapGetters({
      reports: "reports/getSymptomsReports",
      isLoading: "reports/getIsSymptomsLoading",
      totalCount: "reports/getSymptomsTotalCount"
    })
  },
  watch: {
    filter: {
      handler: "fetchReports",
      immediate: true
    }
  },
  methods: {
    fetchReports() {
      this.$store.dispatch("reports/getSymptomsReports", this.filter);
    },
    onPageChange(pageNo, rowsPerPage) {
      this.tableProps.page = pageNo;
      this.filter = {
        ...this.filter,
        pageNo,
        limit: rowsPerPage
      };
    },
    onFilterStartDateChange(value) {
      this.tableProps = {
        ...this.tableProps,
        page: 1
      };
      this.filter = {
        ...this.filter,
        fromDate: value
      };
    },
    onFilterEndDateChange(value) {
      this.tableProps = {
        ...this.tableProps,
        page: 1
      };
      this.filter = {
        ...this.filter,
        toDate: value
      };
    },
    resetFilters() {
      this.filter = {
        searchValue: "",
        limit: 10,
        pageNo: 1,
        fromDate: this.getFormattedDate(),
        toDate: this.getFormattedDate()
      };
    },
    onSearchText(event) {
      this.tableProps = {
        ...this.tableProps,
        page: 1
      };
      this.filter = {
        ...this.filter,
        searchValue: event.target.value,
        pageNo: 1
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>